import * as React from 'react';
import { IconButton, Input, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { AppContext } from '../../../App';
import { MarkDispatchContext } from '../../../context/MarkContext';
import { useNavigate, useParams } from 'react-router';

interface StepperInputProps {
  docIndex: number;
  steps: number;
  review: boolean;
}

const StepperInput: React.FC<StepperInputProps> = ({ docIndex, steps, review }) => {
  const dispatch = React.useContext<React.Dispatch<any>>(MarkDispatchContext);
  const [value, setValue] = React.useState(docIndex + 1);
  const { ids, dataPoolId } = React.useContext(AppContext);
  const navigate = useNavigate();
  const { id, tid } = useParams<{ id: string; tid: string }>();

  const handleStepUpdate = () => {
    if (value > 0 && value <= steps) {
      dispatch({ type: 'RESET_PAGE', payload: { resetFieldAndPage: false } });
      /*
      review
        ? navigate(
            `/data-pools/${dataPoolId}/review/${id}/extraction/${
              ids[value - 1]
            }`
          )
        : navigate(
            `/data-pools/${dataPoolId}/train/${id}/mark/${ids[value - 1]}`
          );
          */
      if (review) {
        navigate(`/data-pools/${dataPoolId}/extraction-batch/${id}/review/${ids[value - 1]}`);
      } else {
        navigate(`/data-pools/${dataPoolId}/train/${id}/mark/${ids[value - 1]}`);
      }
    } else {
      alert(`Please make sure the number is less than ${steps}`);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    setValue(parseInt(e.target.value, 10));
  };

  const handleKeyPress = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleStepUpdate();
    }
  };

  return (
    <span style={{ paddingLeft: 8, paddingRight: 8 }}>
      <Input
        id="step"
        type="number"
        margin="dense"
        sx={{ width: 55, minWidth: 55 }}
        inputProps={{
          style: { textAlign: 'right', padding: '2px 4px' },
          min: '1',
          max: steps,
        }}
        value={value}
        onChange={handleChange}
        onKeyPress={handleKeyPress}
        data-cy="input-doc-stepper"
      />
      <Typography style={{ display: 'inline' }}> / {steps}</Typography>
    </span>
  );
};

export default StepperInput;
